import { FDStack } from '@facet-wealth/design';
import fr from 'facet-rest';
import { Box } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4';
import {
  MoneyFlowLottie,
} from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedCommon/MoneyFlowLottie';
import React from 'react';
import useMobileLayout from 'Hooks/useMobileLayout';
import PropTypes from 'prop-types';

export const MoneyFlowLottieMobile = ({ resource }) => {
  const isMobile = useMobileLayout();
  return (
    <FDStack width={'100%'} alignItems={'center'} height={'100%'} overflow={'hidden'}>
      {isMobile ? resource.withRelationship(fr.relationships.lottie.name,
        (rel) => (
          <Box sx={{
            zIndex: 0,
            transform: 'rotate(90deg)', // Rotate the animation by 90 degrees since the lottie is oriented differently on mobile
            overflow: 'hidden',
          }}
          >
            <MoneyFlowLottie src={rel.link('related').url()} />
          </Box>),
        () => null) : null}
    </FDStack>
  );
};

MoneyFlowLottieMobile.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};
